
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 1000 801.11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M598.18 92a16.65 16.65 0 00-1-1.51h.29zM586.399 12.708a18.75 18.75 0 01-1.27 1.92zM846.083 707.345l-78.395-16.549-66.347-262.958 56.049-49.18 32.258 24.146c11.626 142.093 74.765 201.548 197.656 286.467l-57.283 8.825zM678.395 610.089a96.755 90.178 0 01-94.858 90.188H100.362a96.791 90.211 0 010-180.422h483.235a96.78 90.2 0 0194.798 90.234zM468.599 541.478h-1.63zM466.999 702.698h1.63z"}}),_c('path',{attrs:{"d":"M598.18 92a16.65 16.65 0 00-1-1.51h.29zM585.129 14.588l1.27-1.92a18.75 18.75 0 01-1.27 1.92zM599.85 95.49L598.18 92a20 20 0 011.67 3.49z"}}),_c('path',{attrs:{"d":"M585.129 14.588l1.27-1.92a18.75 18.75 0 01-1.27 1.92zM599.85 95.49L598.18 92a20 20 0 011.67 3.49z"}}),_c('path',{attrs:{"d":"M586.399 12.708a18.75 18.75 0 01-1.27 1.92zM184.906 184.494l149.817-1.982 87.185 157.714 123.593.655 57.852 134.168-501.662-1.494zM595.226 391.917l81.687 43.254L706.3 536.244l-73.277-64.222z"}})])
          )
        }
      }
    